import { ChangeDetectionStrategy, Component, Injector, Input, ViewEncapsulation } from '@angular/core';
import { FiChecklistTimeIntervalType } from '@fi-shared/checklist/schedule/fi-checklist-time-interval-type';
import { FiChecklist2ScheduleFactoryService } from '@fi-shared/checklist/schedule/services/fi-checklist2-schedule-factory.service';
import { FiChecklist2ScheduleFormatService } from '@fi-shared/checklist/schedule/services/fi-checklist2-schedule-format.service';
import { FiChecklistScheduleType } from '../../fi-checklist-schedule-type';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ControlValueAccessorValidatorBase } from '@fi-shared/control-value-accessor-validator-base';

@Component({
    selector: 'fi-checklist2-schedule-edit-time-interval-type',
    templateUrl: './time-interval-type.component.html',
    styleUrls: ['./time-interval-type.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-checklist2-schedule-edit-time-interval-type' },
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: FiChecklist2ScheduleEditTimeIntervalTypeComponent,
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: FiChecklist2ScheduleEditTimeIntervalTypeComponent,
            multi: true,
        },
    ],
    standalone: false,
})
export class FiChecklist2ScheduleEditTimeIntervalTypeComponent extends ControlValueAccessorValidatorBase<FiChecklistTimeIntervalType> {
    @Input() scheduleType: FiChecklistScheduleType;

    constructor(
        private injector: Injector,
        private fiChecklist2ScheduleFactoryService: FiChecklist2ScheduleFactoryService,
        private fiChecklist2ScheduleFormatService: FiChecklist2ScheduleFormatService,
    ) {
        super(injector);
    }

    getTimeIntervalTypeText(timeIntervalType: FiChecklistTimeIntervalType): string {
        return this.fiChecklist2ScheduleFormatService.getTimeIntervalTypeText(timeIntervalType);
    }

    getTimeIntervalTypeDescriptionText(timeIntervalType: FiChecklistTimeIntervalType): string {
        return this.fiChecklist2ScheduleFormatService.getTimeIntervalTypeDescriptionText(timeIntervalType);
    }

    getTimeIntervalTypes(): FiChecklistTimeIntervalType[] {
        return this.fiChecklist2ScheduleFactoryService.getTimeIntervalTypesByScheduleType(this.scheduleType);
    }

    onIntervalTypeChange() {
        this.ngModelChange.emit(this.ngModel);
    }
}
